export const USERS = 'USERS'
export const EDIT_PROFILE = 'EDIT_PROFILE'
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'

export const USER_MANAGE_TAB = 'USER_MANAGE_TAB'
export const USER_DETAILS_TAB = 'USER_DETAILS_TAB'
